import React from "react";
import PitchDeckTableEmptyRow from "../pitch-deck-table/pitch-deck-table-empty-row";
import PitchDeckTableRowHeaderCenter from "../pitch-deck-table/pitch-deck-table-row-center-header";
import PitchDeckTableRowView from "./pitch-deck-table-row-view";

const PitchDeckTableRowsView = ({ data, rowArray }) => {
  return (
    <>
      {rowArray?.map((row, index) =>
        row.type === "rowBreak" ? (
          <PitchDeckTableEmptyRow key={index} />
        ) : row.type === "bodyHeaderCenter" ? (
          <PitchDeckTableRowHeaderCenter
            key={index}
            displayName={row.displayName}
          />
        ) : (
          <PitchDeckTableRowView
            key={index}
            data={data}
            fieldName={row.fieldName}
            displayName={row.displayName}
            className={row.className}
            unitName={row.unitName} // fundingUnit, ARRUnit
            displayUnit={row.displayUnit} // e.g %, USD, employees, etc
            renderContent={row.renderContent} // for unique data rendering
          />
        )
      )}
    </>
  );
};

export default PitchDeckTableRowsView;
